import * as React from 'react';

import AssetPairLoading from 'basics/loaders/AssetPairLoading/AssetPairLoading';
import ContentPlaceholder from 'basics/loaders/ContentPlaceholder/ContentPlaceholder';
import { Bar, SkeletonStack } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import { Header, Pair, Row, Value } from './VoteTableLoading.styled';

const VoteTableLoading = () => (
    <ContentPlaceholder label="Loading markets">
        <Header aria-hidden="true">
            <span>Market</span>
            <span>Users Voted</span>
            <span>Votes</span>
            <span>Your Vote</span>
        </Header>
        {Array.from({ length: 5 }, (_, index) => (
            <Row key={index} aria-hidden="true">
                <Pair>
                    <AssetPairLoading />
                    <SkeletonStack>
                        <Bar $width="12rem" $height="2rem" />
                        <Bar $width="16rem" />
                    </SkeletonStack>
                </Pair>
                <Value>
                    <span>Users Voted:</span>
                    <Bar $width="4rem" $height="2rem" />
                </Value>
                <Value>
                    <span>Votes:</span>
                    <SkeletonStack>
                        <Bar $width="10rem" $height="2rem" />
                        <Bar $width="12rem" $height="0.8rem" />
                    </SkeletonStack>
                </Value>
                <Bar $width="16rem" $height="4.8rem" />
            </Row>
        ))}
    </ContentPlaceholder>
);

export default VoteTableLoading;
